
import { defineComponent, PropType } from 'vue';
import axios from "axios";
import {heightURL, municipalityURL} from "@/config/app-settings";
import LocationPickerMap from "@/components/picker/LocationPickerMap.vue";
import L from 'leaflet';
import InputNumber from "primevue/inputnumber";

export default defineComponent({
  name: "LocationPicker",
  components: {LocationPickerMap, InputNumber},
  data() {
    return {
      x: null as number | null,
      y: null as number | null,
      municipality: '',
      height: '',
      map: {} as L.Map,
      nameProp: this.name,
      valueProp: this.value,
    }
  },
  props: {
    name: {type: String, required: true},
    value: {
      type: Array as PropType<Array<number>>, required: true
    }
  },
  methods: {
    getMunicipality() {
      if (this.x && this.y) {
        axios.get(municipalityURL + Math.round(this.x) + "/" + Math.round(this.y))
            .then(res => this.municipality = res.data)
      }
    },
    getHeight() {
      if (this.x && this.y) {
        axios.get(heightURL + Math.round(this.x) + "/" + Math.round(this.y))
            .then(res => this.height = res.data.toFixed(0))
      }
    },
    setCoords(coords: [number, number]) {
      this.x = coords[0]
      this.y = coords[1]
    }
  },
  watch: {
    x() {
      this.$emit('select', { key: this.nameProp, value: [this.x, this.y]})
      this.getMunicipality()
      this.getHeight()
    },
    y() {
      this.$emit('select', { key: this.nameProp, value: [this.x, this.y]})
      this.getMunicipality()
      this.getHeight()
    }
  },
  mounted() {
    this.x = this.valueProp ? this.valueProp[0] : null
    this.y = this.valueProp ? this.valueProp[1] : null
  }

})
